export const EDIT_CONFLICT_TEXT = 'Otra persona cambió esto mientras editabas. Recarga para ver su versión.';
export const EDIT_CONFLICT_API_MESSAGE = 'Someone else changed this while you were editing';

export type GoneKind = 'marker' | 'panorama' | 'tour';

/** What the user sees when what they were saving was deleted by someone else (no name: the API does not record who). */
export const GONE_TEXT: Record<GoneKind, string> = {
  marker: 'Otra persona eliminó este punto.',
  panorama: 'Otra persona eliminó esta panorámica.',
  tour: 'Otra persona eliminó este tour.',
};

